import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { Workspace } from '@/hooks/api/models';

/**
 * 0200. チーム編集
 * [PUT] /workspaces/:identifier/teams/:id
 */
type Props = {
  identifier: string;
  id: number;
  name: string;
  description: string;
  agency_enabled: boolean;
  sales_order_menu_listed: boolean;
  purchase_order_menu_listed: boolean;
};
export const updateTeam = (props: Props): Promise<Workspace> => {
  return axios.put(`/api/workspaces/${props.identifier}/teams/${props.id}`, props);
};

export const useUpdateTeam = () => {
  return useMutation({
    mutationFn: updateTeam,
  });
};
